module.exports = __webpack_public_path__ + "static/electronicdiaries-86a726aaec63a6f30cc937d52957c047.jpg";